import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=3960d634&scoped=true&"
import script from "./event-list.vue?vue&type=script&lang=js&"
export * from "./event-list.vue?vue&type=script&lang=js&"
import style0 from "./event-list.vue?vue&type=style&index=0&id=3960d634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960d634",
  null
  
)

export default component.exports